export default {
  paged: {
    select: 'id,name,description,color,isActive',
    searchSelect: ['name', 'description'],
    orderBy: 'name',
  },
  item: {
    select: 'id,name,description,color,isActive',
  },
  itemDetail: {
    select: 'id,name,description,color,isActive,creator,modifier,created,updated',
  },
};
